<template>
    <div>
        <headline>
          Austattung
        </headline>

        <loading v-show="loading"></loading>

        <card-full-invisible v-show="!loading">
                <tailwind-table :header="header">
                    <tr v-for="(desk, i) in filteredDesks" :class="{'bg-white': i%2}">
                        <td class="px-6 py-3 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                            {{ desk.floor?.name }}
                        </td>
                        <td class="px-6 py-3 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                            {{ desk.name }}
                        </td>
                        <td v-for="(attribute) in attributes" class="px-6 py-3">
                            <a @click="toggle(desk, attribute)" class="cursor-pointer">
                                <i class="fa" :class="{
                                    'fa-check-circle text-green-500':has(desk, attribute),
                                    'fa-circle-thin text-gray-400': !has(desk, attribute),
                                }"></i>
                            </a>
                        </td>
                    </tr>
                </tailwind-table>
        </card-full-invisible>
    </div>
</template>

<script>
import UserGroups from "../components/UserGroups";
import ButtonPrimary from "../components/UI/ButtonPrimary";
import Modal from "../components/Modal";
import ConfirmDialog from "../components/UI/ConfirmDialog";
import Loading from "../components/UI/Loading";
import ButtonWhite from "../components/UI/ButtonWhite";
import Headline from "../components/UI/Headline";
import InputField from "../components/UI/InputField";
import CardFullInvisible from "../components/UI/CardFullInvisible";
import ButtonDelete from "../components/UI/ButtonDelete";
import ButtonSecondary from "../components/UI/ButtonSecondary";
import SelectMenu from "../components/UI/SelectMenu";
import TailwindTable from "../components/UI/TailwindTable.vue";
import AlertDialog from "../components/UI/AlertDialog.vue";

export default {
  name: "DeskAttributes",
  components: {
    AlertDialog,
    TailwindTable,
    SelectMenu,
    ButtonSecondary,
    ButtonDelete,
    CardFullInvisible,
    InputField,
    Headline,
    ButtonWhite,
    Loading,
    ConfirmDialog,
    Modal,
    ButtonPrimary,
    UserGroups,
  },

  props: ['group'],

  data: () => ({
    desks: [],
    filteredDesks: [],
    attributes: [],

    loading: false,
  }),

  created() {
    this.load();
  },

  computed: {

    header() {
      return ['Etage','Schreibtische'].concat(this.attributes.map(u => u.name));
    },
  },

  methods: {
    load() {
      this.loading = true;
      window.axios.get('/admin/attributes').then(result => {
        this.attributes = result.data.data;
        this.loading = false;
      });
      window.axios.get('/admin/desks').then(result => {
        this.desks = result.data.desks;
        this.filteredDesks = this.desks;
        this.floors = result.data.floors;
        this.loading = false;
      });
    },
    has(desk, attr) {
      return desk.attributes.some(a=>a.id===attr.id);
    },
    toggle(desk, attr) {
      if(this.has(desk,attr)){
        desk.attributes.splice(desk.attributes.findIndex(a=>a.id===attr.id),1);
      }else{
        desk.attributes.push(attr);
      }
      this.$http.post(`/admin/desks/${desk.id}`,{
        _method: 'put',
        attributes: desk.attributes.map(a=>a.id)
      }).then(
      ).catch((error)=>{
        this.$root.$emit('error', error);
      });
    },
  }
}
</script>

<style scoped>
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
</style>
